import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Notification from "rc-notification";
import axios from "axios";
import { Button } from "../../components/Button";
import "./styles.less";
import { Input } from "../../components/Input";
import { useTranslation } from "react-i18next";

export const Contact = (props) => {
  const { title, subtitle } = props;
  const { handleSubmit, register, reset, errors } = useForm();
  const { t } = useTranslation();
  const onSubmit = async (values) => {
    let notification = null;
    Notification.newInstance(
      { style: { top: 65, left: "50%", transform: "translateX(-50%)" } },
      (n) => (notification = n)
    );
    const { data: res } = await axios.post("/api/contact-us", values);
    if (res.code === 200) {
      notification.notice({
        content: (
          <span>
            <i className="icon authing-icon authing-wancheng ntf-success-icon"></i>
            {t("common.form.success-tip")}
          </span>
        ),
        duration: 5,
      });
      reset();
    }
  };

  return (
    <section>
      <div className="authing-contact-warp">
        <div className="authing-contact">
          <div className="banner-img">
            <img
              src={`//files.authing.co/authing-website/aboutus-banner-bottom.jpg`}
              alt="authing contact"
            />
          </div>

          <div className="banner-content">
            <div className="title">{title}</div>
            <div className="subtitle">{subtitle}</div>
            <form className="form-box" onSubmit={handleSubmit(onSubmit)}>
              <div className="form-item">
                <div className="form-label required">
                  {t("common.form.name")}
                </div>
                <div className="form-input">
                  <Input
                    placeholder={t("common.form.name-placeholder")}
                    error={errors.name}
                    type="text"
                    name="name"
                    inputRef={register({
                      required: true,
                    })}
                  />
                </div>
              </div>
              <div className="form-item">
                <div className="form-label required">
                  {t("common.form.phone")}
                </div>
                <div className="form-input">
                  <Input
                    placeholder={t("common.form.phone-placeholder")}
                    type="text"
                    name="phone"
                    error={errors.phone}
                    inputRef={register({
                      required: true,
                    })}
                  />
                </div>
              </div>
              <div className="form-item">
                <div className="form-label ">{t("common.form.company")}</div>
                <div className="form-input">
                  <Input
                    placeholder={t("common.form.company-placeholder")}
                    type="text"
                    name="company"
                    error={errors.company}
                  />
                </div>
              </div>
              <div className="form-item">
                <div className="form-label ">{t("common.form.position")}</div>
                <div className="form-input">
                  <Input
                    placeholder={t("common.form.position-placeholder")}
                    type="text"
                    name="position"
                    error={errors.position}
                  />
                </div>
              </div>
              <div className="form-item">
                <div className="form-label">{t("common.form.other")}</div>
                <div className="form-input">
                  <textarea
                    rows="2"
                    cols="30"
                    name="other"
                    ref={register()}
                    style={{ paddingTop: 10 }}
                  ></textarea>
                </div>
              </div>
              <Button type="submit" className="form-button">
                {t("common.form.submit")}
              </Button>
            </form>
          </div>
        </div>
        <div className="contact-bg"></div>
      </div>
    </section>
  );
};
